module.exports = __webpack_public_path__ + "img/23.46ed0690.svg";